import { FormattedMessage } from '@alltrails/shared/react-intl';
import useUser from 'hooks/useUser';
import * as styles from './ProStatus.module.scss';

type Props = {
  isAppleSubscription: boolean;
};

function ExpirationDateLabel() {
  const user = useUser();

  if (!user?.expirationDate) {
    return <FormattedMessage defaultMessage="Unknown" />;
  }

  const expirationDate = new Date(user.expirationDate);

  if (user.subscription?.trial) {
    return <FormattedMessage defaultMessage="Your trial will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
  }

  return <FormattedMessage defaultMessage="Your subscription will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
}

function AppleExpirationDateLabel() {
  const user = useUser();

  if (!user?.expirationDate) {
    return <FormattedMessage defaultMessage="Unknown" />;
  }

  const expirationDate = new Date(user.expirationDate);

  if (user.subscription?.trial) {
    return <FormattedMessage defaultMessage="Your trial will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
  }

  return <FormattedMessage defaultMessage="Your current subscription will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
}

function ExpirationDate({ isAppleSubscription }: Props) {
  const user = useUser();

  if (isAppleSubscription) {
    return (
      <>
        <div className={styles.settingsPro}>
          <span className={styles.subtitle}>
            <FormattedMessage defaultMessage="Expiration date:" />{' '}
          </span>
          <span>
            <AppleExpirationDateLabel />
          </span>
        </div>
        <div className={styles.settingsPro}>
          <span>
            <a href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/manageSubscriptions" target="_blank" rel="noreferrer">
              <FormattedMessage defaultMessage="Check autorenewal status" />
            </a>
          </span>
        </div>
      </>
    );
  }

  return (
    <div className={styles.settingsPro}>
      {user.subscription?.plan === 'alltrails_pro_lifetime' ? (
        <span className={styles.subtitle}>
          <FormattedMessage defaultMessage="Lifetime member" />
        </span>
      ) : (
        <>
          <span className={styles.subtitle}>
            <FormattedMessage defaultMessage="Expiration date:" />{' '}
          </span>
          <ExpirationDateLabel />
        </>
      )}
    </div>
  );
}

export default ExpirationDate;
